export default {choose_newsletter:'Выберите рассылки из списка.',email_please:'Ваш e-mail?'};